import get from 'lodash/get';
// @ts-ignore
import { getHints } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import { HAS_NOT_SEEN_NEW_SUBJECT_MODAL } from './typings';

export const getShouldShowNewSubjectModal = createSelector([getHints], (hints): boolean =>
    get(hints, HAS_NOT_SEEN_NEW_SUBJECT_MODAL, false)
);
